import React from 'react';
import { object, func, bool } from 'prop-types';
import styles from './EditDish.scss';
import Banner, { BANNER_TYPES } from '../Banner/Banner';
import VariationRadio from './VariationRadio';
import VariationCheckbox from './VariationCheckbox';
import ArrowIcon from './ArrowIcon';
import { Element } from 'react-scroll';
import classNames from 'classnames';
import { translate } from 'react-i18next';
import { getLimitationString } from '../../utils/DishUtils';
import { Text } from 'wix-style-react';

function Variation({
  part,
  onChange,
  displayErrorIndication,
  errorIndicationOverrides,
  indent,
  showArrow,
  disabled,
  t,
}) {
  const { limitation, min, max } = part;
  const style = indent ? { marginLeft: 24 } : {};
  const isCheckbox = part.type === 'variation.checkbox';
  const selectionProps = {
    part,
    onChange,
    displayErrorIndication,
    errorIndicationOverrides,
    disabled,
  };

  const displayError =
    part.limitation && displayErrorIndication && errorIndicationOverrides[part.clientSideId] === 'visible';

  return (
    <div style={style} className={styles.variation} key={part.clientSideId} data-hook={part.clientSideId}>
      <div className={styles.variationTitle}>
        <Element name={part.clientSideId}>
          {indent && showArrow && (
            <div className={styles.arrow}>
              <ArrowIcon />
            </div>
          )}
          <Text
            size="medium"
            weight="bold"
            data-hook="edit-dish-variation-title"
            className={classNames({ [styles.hasLimitation]: part.limitation })}
          >
            {part.title}
          </Text>
        </Element>
        {part.limitation && !displayError && (
          <Text size="small" weight="normal" secondary tagName="div" data-hook="edit-dish-variation-limitation">
            {getLimitationString({ limitation, min, max, t })}
          </Text>
        )}
      </div>
      {displayError && !part.isValid && (
        <Banner type={BANNER_TYPES.ERROR} className={styles.variationError}>
          {t('phoneordering_checkout_error_required')}
        </Banner>
      )}
      <Text size="small" weight="normal" tagName="div">
        {isCheckbox ? <VariationCheckbox {...selectionProps} /> : <VariationRadio {...selectionProps} />}
      </Text>
    </div>
  );
}

Variation.propTypes = {
  part: object,
  onChange: func,
  displayErrorIndication: bool,
  errorIndicationOverrides: object,
  indent: bool,
  showArrow: bool,
  disabled: bool,
};

export default translate()(Variation);
